import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import Document from "components/PrimeiroAcesso/Document";
import RegisterPassword from "components/PrimeiroAcesso/RegisterPassword";
import SideBanner from "components/layout/SideBanner";
import SuccessRegister from "components/PrimeiroAcesso/SuccessRegister";
import TokenAccess from "components/PrimeiroAcesso/TokenAccess";
import { toggleFirstStep } from "store/actions/first-access-mi-actions";

import { Container, Content } from "./styles";

const PrimeiroAcesso = (): JSX.Element => {
  const { step, firstStep } = useSelector(
    // @ts-ignore
    (state) => state.firstAccessReducer
  );

  const header = useMemo(() => {
    switch (step) {
      case 1:
        return {
          h1: "Identificação",
          h2: "Informe seu CPF ou CNPJ de cadastro para continuar",
        };
      case 2:
        return {
          h1: `Localizamos seu cadastro. Agora vamos te identificar por (${
            !firstStep ? "email" : "telefone"
          })`,
          h2: `Selecione uma das opções dos ${
            !firstStep ? "emails" : "telefones"
          } abaixo para validação.`,
        };
      case 3:
        return {
          h1: "Estamos quase lá!",
          h2: "Agora vamos criar uma senha",
        };
      case 4:
        return {
          h1: "Tudo certo!!",
          h2: "Agora você pode acessar seu portal e visualizar todas suas unidades em um único login.",
        };
      default:
        return {
          h1: "",
          h2: "",
        };
    }
  }, [step]);

  const steppers = useMemo(() => {
    if (step === 1) {
      return ["Identificação"];
    }

    return ["Identificação", "Dados pessoais", "Cadastro de senha", "Fim"];
  }, [step]);

  const buildComponent = useMemo(() => {
    if (step === 1 && firstStep) {
      toggleFirstStep();
    }

    switch (step) {
      case 1:
        return <Document />;
      case 2:
        return <TokenAccess />;
      case 3:
        return <RegisterPassword />;
      case 4:
        return <SuccessRegister />;
      default:
        return <Document />;
    }
  }, [step]);

  return (
    <Container>
      <SideBanner activated={step} header={header} steppers={steppers} />
      <Content>{buildComponent}</Content>
    </Container>
  );
};

export default PrimeiroAcesso;
